import React from 'react';
import OrganizationDashboard from '../components/dashboard/OrganizationDashboard';

const OrganizationDashboardPage = () => {
  return <OrganizationDashboard />;
};

export default OrganizationDashboardPage;

